var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex align-items-start" },
    [
      _c("dropdown", {
        attrs: {
          ddClasses: "scrawl-scrollable-dropdown",
          label: "NIHSS (text output)",
          items: _vm.simpleNihssList,
          textField: "desc",
          chooseText: "[ None ]",
          value: _vm.textNIHSS
        },
        on: {
          input: function($event) {
            _vm.textNIHSS = $event
          }
        }
      }),
      _vm._v(" "),
      _vm.debugMode && _vm.isPowerUser
        ? _c("dropdown", {
            staticClass: "ml-2",
            attrs: {
              ddClasses: "scrawl-scrollable-dropdown",
              ddToggleClasses: "text-white progress-bar-striped",
              variant: "dummy",
              label: "NIHSS (text output) - All",
              items: _vm.allNihss,
              textField: "desc",
              chooseText: "[ None ]",
              value: _vm.textNIHSS
            },
            on: {
              input: function($event) {
                _vm.textNIHSS = $event
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }